// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    flows: "Flows",
    documentation: "Documentation",
    settingsTab: "Settings",
    fieldsTab: "Fields",
    pagesTab: "Pages",
    flowNotFound: "Flow not found",
  },
  nb_NO: {
    settings: "Innstillinger",
    flows: "Flyter",
    documentation: "Dokumentasjon",
    settingsTab: "Innstillinger",
    fieldsTab: "Felt",
    pagesTab: "Sider",
    flowNotFound: "Flyt ikke funnet",
  },
} as const;
